/**
 * Generate a unique device ID for this browser/device
 * Uses localStorage to persist the ID across sessions
 */
export const getDeviceId = (): string => {
  const storageKey = 'birdbrain-device-id'

  // Try to get existing device ID
  let deviceId = localStorage.getItem(storageKey)

  if (!deviceId) {
    // Generate new device ID: birdbrain- + timestamp + random
    const timestamp = Date.now().toString(36)
    const random = Math.random().toString(36).substring(2, 8)
    deviceId = `birdbrain-${timestamp}-${random}`

    // Store it for future use
    localStorage.setItem(storageKey, deviceId)
  }

  return deviceId
}
